import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { useState } from "react";
import { useEffect } from "react";
import HomeIcon from "./homeIcon";
import "../styles/sideBar.css";
import { signOut } from "firebase/auth";
import CalendarIcon from "./calendarIcon";
import ListIcon from "./listIcon";
import Bell from "./bellIcon";
import PlanerIcon from "./plannerIcon";
import NotePadIcon from "./notepadIcon";
import Gala from "./gala";
import TicketIcon from "./ticketIcon";
import Waiter from "./waiter";
import Archives from "./archives";

export default function SideBar({isToogle, toogle}) {

    const location = useLocation();

    //                     <Link style={({textDecoration: "none"})} to={"/dashboard"}>
    //                         <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", overflowY: "none", gap: "14px", width: "100%"})}>
    //                             <HomeIcon color={location?.pathname === "/dashboard" ? "#0045C7" : "rgb(30,30,30)"} wth={"22px"}/>
    //                             <h3 style={({fontSize: "15px", fontWeight: "normal", color: location?.pathname === "/dashboard" ? "#0045C7" : "rgb(30,30,30)"})}>Strona główna</h3>
    //                         </div>
    //                     </Link>
    //                     <Link style={({textDecoration: "none"})} to={"/admin-listy"}>
    //                         <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", overflowY: "none", gap: "14px", width: "100%"})}>
    //                             <HomeIcon color={location?.pathname === "/admin-listy" ? "#0045C7" : "rgb(30,30,30)"} wth={"22px"}/>
    //                             <h3 style={({fontSize: "15px", fontWeight: "normal", color: location?.pathname === "/admin-listy" ? "#0045C7" : "rgb(30,30,30)"})}>Listy</h3>
    //                         </div>
    //                     </Link>
    //                     <Link style={({textDecoration: "none"})} to={"/admin-grupy"}>
    //                         <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", overflowY: "none", gap: "14px", width: "100%"})}>
    //                             <HomeIcon color={location?.pathname === "/admin-grupy" ? "#0045C7" : "rgb(30,30,30)"} wth={"22px"}/>
    //                             <h3 style={({fontSize: "15px", fontWeight: "normal", color: location?.pathname === "/admin-grupy" ? "#0045C7" : "rgb(30,30,30)"})}>Grupy</h3>
    //                         </div>
    //                     </Link>
    //                     <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", overflowY: "none", gap: "20px", width: "100%", padding: "6px 0px"})} onClick={() => setFinansial(!finansial)}>
    //                         <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "row", overflowY: "none", gap: "14px", width: "100%"})}>
    //                             <img src="cash.svg" style={({width: "22px"})} />
    //                             <h3 style={({fontSize: "15px", fontWeight: "normal"})}>Finanse</h3>
    //                         </div>
    //                         {finansial &&
    //                             <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", overflowY: "none", gap: "15px", width: "100%"})}>
    //                                 <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "row", overflowY: "none", gap: "10px", paddingLeft: "20px"})}>
    //                                     <img src="cash.svg" style={({width: "15px"})} />
    //                                     <h3 style={({fontSize: "13px", fontWeight: "normal"})}>Podsumowanie</h3>
    //                                 </div>
    //                                 <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "row", overflowY: "none", gap: "10px", paddingLeft: "20px"})}>
    //                                     <img src="cash.svg" style={({width: "15px"})} />
    //                                     <h3 style={({fontSize: "13px", fontWeight: "normal"})}>Koszty</h3>
    //                                 </div>
    //                                 <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "row", overflowY: "none", gap: "10px", paddingLeft: "20px"})}>
    //                                     <img src="cash.svg" style={({width: "15px"})} />
    //                                     <h3 style={({fontSize: "13px", fontWeight: "normal"})}>Dochód</h3>
    //                                 </div>
    //                                 <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "row", overflowY: "none", gap: "10px", paddingLeft: "20px"})}>
    //                                     <img src="cash.svg" style={({width: "15px"})} />
    //                                     <h3 style={({fontSize: "13px", fontWeight: "normal"})}>Pracownicy</h3>
    //                                 </div>
    //                             </div>
    //                         }
    //                         {/* <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "row", overflowY: "none", gap: "14px", width: "100%"})}>
    //                             <img src="home.svg" style={({width: "22px"})} />
    //                             <h3 style={({fontSize: "15px"})}>Grupy</h3>
    //                         </div> */}
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </nav>
    // )

    const [isOpen, setIsOpen] = useState(false);
    const [isFinance, setIsFinance] = useState(false);

    const toggleSidebar = () => {
      setIsOpen(!isOpen);
    };
  
    const toggleFinance = () => {
      setIsFinance(!isFinance);
    };

    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await signOut(auth);        
            navigate('/');
        } catch (error) {
            console.error('Błąd podczas wylogowania:', error);
        }
    }

    const [notification, setNotification] = useState([]) 
    const [notificationPanel, setNotificationPanel] = useState(false) 

    return (
      <>
        {!isOpen &&
            <button
            className={`menu-button ${isOpen ? "active" : ""}`}
            onClick={toggleSidebar}
            aria-label="Toggle Menu"
            >
            <div className="menu-icon-bar" />
            <div className="menu-icon-bar" />
            <div className="menu-icon-bar" />
            </button>
        }
  
        <nav className={isToogle ? isOpen ? "sidebar sidebar--open" : `sidebar--toogle` : `sidebar ${isOpen ? "sidebar--open" : ""}`}>  
            <img className="side-arrow" src={process.env.PUBLIC_URL + "/sideArrow.png"} style={({transform: isToogle ? "rotate(180deg)" : "", width: "25px", position: "absolute", right: "-20px", top: "10px", backgroundColor: "#ffffff", padding: "5px", borderRadius: "50px", border: "1px solid rgb(230,230,230)", zIndex: "2000", cursor: "pointer"})} onClick={toogle}/>
            <ul>
                <img src={process.env.PUBLIC_URL + "/logo4STARS.png"} style={({width: isToogle ? isOpen ? "0px" : "60px" : "0px"})}/>
                <img src={process.env.PUBLIC_URL + "/logo_fullname_black.png"} style={({width: isToogle ? isOpen ? "100%" : "0px" : "100%"})}/>
                {/* <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/panel-admina"} onClick={() => setIsOpen(false)}>
                    <li>
                        <HomeIcon color={location?.pathname === "/panel-admina" ? "#0045C7" : "rgb(30,30,30)"} wth={"20px"}/>
                        <h3 style={({color: location?.pathname === "/panel-admina" ? "#0045C7" : "rgb(30,30,30)"})}>Panel administratora</h3>
                    </li>
                </Link> */}
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/oczekujacy"} onClick={() => setIsOpen(false)}>
                    <li>
                        <Waiter color={location?.pathname === "/oczekujacy" ? "#0045C7" : "rgb(30,30,30)"} wth={"30px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/oczekujacy" ? "#0045C7" : "rgb(30,30,30)"})}>Osoby oczekujące</h3>}
                    </li>
                </Link>
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/frekwencja-admin"} onClick={() => setIsOpen(false)}>
                    <li>
                        <CalendarIcon color={location?.pathname === "/frekwencja-admin" ? "#0045C7" : "rgb(30,30,30)"} wth={"30px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/frekwencja-admin" ? "#0045C7" : "rgb(30,30,30)"})}>Kalendarz i frekwencja</h3>}
                    </li>
                </Link>
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/listy"} onClick={() => setIsOpen(false)}>
                    <li>
                        <ListIcon color={location?.pathname === "/listy" ? "#0045C7" : "rgb(30,30,30)"} wth={"30px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/listy" ? "#0045C7" : "rgb(30,30,30)"})}>Lista uczestników</h3>}
                    </li>
                </Link>
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/archiwum"} onClick={() => setIsOpen(false)}>
                    <li>
                        <Archives color={location?.pathname === "/archiwum" ? "#0045C7" : "rgb(30,30,30)"} wth={"27px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/archiwum" ? "#0045C7" : "rgb(30,30,30)"})}>Archiwum</h3>}
                    </li>
                </Link>
                {/* <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/planner"} onClick={() => setIsOpen(false)}>
                    <li>
                        <PlanerIcon color={location?.pathname === "/planner" ? "#0045C7" : "rgb(30,30,30)"} wth={"30px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/planner" ? "#0045C7" : "rgb(30,30,30)"})}>Planer Social Media</h3>}
                    </li>
                </Link> */}
                {/* <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/gala"} onClick={() => setIsOpen(false)}>
                    <li>
                        <Gala color={location?.pathname === "/gala" ? "#0045C7" : "rgb(30,30,30)"} wth={"23px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/gala" ? "#0045C7" : "rgb(30,30,30)"})}>Menadżer Gali </h3>}
                    </li>
                </Link>
                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/bilety"} onClick={() => setIsOpen(false)}>
                    <li>
                        <TicketIcon color={location?.pathname === "/bilety" ? "#0045C7" : "rgb(30,30,30)"} wth={"23px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/bilety" ? "#0045C7" : "rgb(30,30,30)"})}>Menadżer Biletów </h3>}
                    </li>
                </Link> */}
                {/* <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/notatnik"} onClick={() => setIsOpen(false)}>
                    <li>
                        <NotePadIcon color={location?.pathname === "/notatnik" ? "#0045C7" : "rgb(30,30,30)"} wth={"30px"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: location?.pathname === "/notatnik" ? "#0045C7" : "rgb(30,30,30)"})}>Notatnik</h3>}
                    </li>
                </Link> */}
                {/* <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/admin-grupy"} onClick={() => setIsOpen(false)}>
                    <li>
                        <HomeIcon color={location?.pathname === "/admin-grupy" ? "#0045C7" : "rgb(30,30,30)"} wth={"22px"}/>
                        <h3 style={({color: location?.pathname === "/admin-grupy" ? "#0045C7" : "rgb(30,30,30)"})}>Listy</h3>
                    </li>
                </Link> */}
                {/* <div className="submenu-container">
                    <div style={({display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "space-between", width: "100%", zIndex: "5"})} className="submenu-div" onClick={() => toggleFinance()}>
                        <div style={({display: "flex", flexDirection: "row", gap: "10px", alignItems: "center"})}>
                            <HomeIcon color="rgb(30,30,30)" wth={"22px"}/>
                            <h3 style={({color: "rgb(30,30,30)", fontSize: "15px"})}>Finanse</h3>
                        </div>
                        <span className="arrow">{isFinance ? "▲" : "▼"}</span>
                    </div>
                    {(isFinance || (location?.pathname === "/finanse/podsumowanie" || location?.pathname === "/finanse/raporty" || location?.pathname === "/finanse/statystyki" || location?.pathname === "/finanse/rozliczenia")) && 
                        <ul className="submenu">
                            {(isFinance || location?.pathname === "/finanse/podsumowanie") && 
                                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/finanse/podsumowanie"}>
                                    <li style={({display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", width: "200px"})}>
                                        <HomeIcon color={location?.pathname === "/finanse/podsumowanie" ? "#0045C7" : "rgb(30,30,30)"} wth={"17px"}/>
                                        <h3 style={({color: location?.pathname === "/finanse/podsumowanie" ? "#0045C7" : "rgb(30,30,30)", fontSize: "13px"})}>Podsumowanie</h3>
                                    </li>
                                </Link>
                            }
                            {(isFinance || location?.pathname === "/finanse/raporty") && 
                                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/finanse/raporty"}>
                                    <li style={({display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", width: "200px"})}>
                                        <HomeIcon color={location?.pathname === "/finanse/raporty" ? "#0045C7" : "rgb(30,30,30)"} wth={"17px"}/>
                                        <h3 style={({color: location?.pathname === "/finanse/raporty" ? "#0045C7" : "rgb(30,30,30)", fontSize: "13px"})}>Raporty</h3>
                                    </li>
                                </Link>
                            }
                            {(isFinance || location?.pathname === "/finanse/statystyki") && 
                                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/finanse/statystyki"}>
                                    <li style={({display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", width: "200px"})}>
                                        <HomeIcon color={location?.pathname === "/finanse/statystyki" ? "#0045C7" : "rgb(30,30,30)"} wth={"17px"}/>
                                        <h3 style={({color: location?.pathname === "/finanse/statystyki" ? "#0045C7" : "rgb(30,30,30)", fontSize: "13px"})}>Statystyki</h3>
                                    </li>
                                </Link>
                            }
                            {(isFinance || location?.pathname === "/finanse/rozliczenia") && 
                                <Link style={({textDecoration: "none", width: "100%", WebkitTapHighlightColor: "transparent"})} to={"/finanse/rozliczenia"}>
                                    <li style={({display: "flex", flexDirection: "row", gap: "8px", alignItems: "center", width: "200px"})}>
                                        <HomeIcon color={location?.pathname === "/finanse/rozliczenia" ? "#0045C7" : "rgb(30,30,30)"} wth={"17px"}/>
                                        <h3 style={({color: location?.pathname === "/finanse/rozliczenia" ? "#0045C7" : "rgb(30,30,30)", fontSize: "13px"})}>Rozliczenia</h3>
                                    </li>
                                </Link>
                            }
                        </ul>
                    }
                </div> */}
            </ul>
            <ul>
                <li onClick={() => setNotificationPanel(true)}>
                        <Bell wth="23px" color={(notification && notification?.length > 0) ? "#0045C7" : "rgb(30,30,30)"}/>
                        {(!isToogle || isOpen) && <h3 style={({color: "rgb(30,30,30)"})}>{(notification && notification?.length > 0) ? `Nowe powiadomienia (${notification?.length})` : "Brak powiadomień"}</h3>}
                </li>
                    <li onClick={() => handleLogout()}>
                        <img src={process.env.PUBLIC_URL + "logout.svg"} style={({width: "22px"})}/>
                        {(!isToogle || isOpen) && <h3 style={({color: "rgb(30,30,30)"})}>Wyloguj się</h3>}
                    </li>
            </ul>
        </nav>
        {isOpen && <div className="overlay" onClick={toggleSidebar} />}
        {(notificationPanel && notification) &&
            <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%", height: "100%", transition: "0.5s", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", zIndex: "3000"})} onClick={() => setNotificationPanel(false)}>
                <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "90%", height: "350px", transition: "0.5s", backgroundColor: "rgb(250,250,250)", borderRadius: "5px", maxWidth: "500px"})} onClick={(e) => e.stopPropagation()}>
                </div>
            </div>
        }
      </>
    );
}